import { Select } from 'antd'

import { DataError } from '@eastcoal/common/components/DataError'
import { pick } from '@eastcoal/common/utils/object'

import { useKindRootNodeStore } from '../../Store/hooks/useStore'

import { KindRootNodeSelectCoreProps } from './interface'

const fieldNames = {
  label: 'name',
  value: 'id',
  children: 'children'
}

export const KindRootNodeSelectCore = ({
  allowClear = true,
  disabled,
  placeholder
}: KindRootNodeSelectCoreProps) => {
  const {
    data,
    error,
    loading,
    reload,
    multiple,
    selectedKeys,
    setSelectedKeys
  } = useKindRootNodeStore(state =>
    pick(state, [
      'data',
      'error',
      'loading',
      'reload',
      'multiple',
      'selectedKeys',
      'setSelectedKeys'
    ])
  )

  return error ? (
    <DataError error={error} loading={loading} reload={reload} />
  ) : (
    <Select
      allowClear={allowClear}
      disabled={disabled}
      fieldNames={fieldNames}
      labelInValue={false}
      loading={loading}
      mode={multiple ? 'multiple' : undefined}
      options={data}
      placeholder={placeholder}
      value={selectedKeys}
      onChange={setSelectedKeys as any}
    />
  )
}
